export const IMPROVE_VTE_RISK_ASSESSMENT = {
    masterTableName: "MC_IMPROVE_VTE_RISK_ASSESSMENT",
    tableName: "MC_IMPROVE_VTE_RAST_DET",
    columnName: "IVRA_ID",
    columnValue: 0,
    title: "improve-vte-risk-assessment.title",
    rows: [
      { title: "id", value: "ID" },
      { title: "date", value: "PROCESS_TIME", type: "date" },
      { title: "CUSER", value: "CUSER" },
      { title: "age", value: "AGE_XNAME" },
      { title: "vte_history", value: "VTE_HISTORY_XNAME" },
      { title: "thrombophilia", value: "THROMBOPHIA_XNAME" },
      { title: "cancer", value: "CANCER_XNAME" },
      { title: "lower_extremity", value: "EXMY_PARALYSIS_OR_PARES_XNAME" },
      { title: "immobilization", value: "IMMOBILIZATION_XNAME" },
      { title: "ybu", value: "YBU_XNAME" },
      { title: "total_score", value: "CALC_VALUE" },
    ],
    fields: [
      { field: "date", headerName: "datetime", flex: 1 },
      { field: "CUSER", headerName: "createdby", flex: 1 },
      { field: "age", headerName: "improve-vte-risk-assessment.age", flex: 1 },
      { field: "vte_history", headerName: "improve-vte-risk-assessment.vte-history", flex: 1 },
      { field: "thrombophilia", headerName: "improve-vte-risk-assessment.thrombophilia", flex: 1 },
      { field: "cancer", headerName: "improve-vte-risk-assessment.cancer", flex: 1 },
      { field: "lower_extremity", headerName: "improve-vte-risk-assessment.lower-extremity-paralysis-or-paresthesia", flex: 1 },
      { field: "immobilization", headerName: "improve-vte-risk-assessment.immobilization", flex: 1 },
      { field: "ybu", headerName: "improve-vte-risk-assessment.icu-or-coronary-icu-stay", flex: 1 },
      {
        field: "total_score",
        headerName: "score",
        flex: 1,
        computed: true,
        calculate: (row: any) => {
          if (!row) return 0;
          const age = Number(row.AGE_XVALUE) || 0;
          const vteHistory = Number(row.VTE_HISTORY_XVALUE) || 0;
          const thrombophilia = Number(row.THROMBOPHIA_XVALUE) || 0;
          const cancer = Number(row.CANCER_XVALUE) || 0;
          const lowerExtremity = Number(row.EXMY_PARALYSIS_OR_PARES_XVALUE) || 0;
          const immobilization = Number(row.IMMOBILIZATION_XVALUE) || 0;
          const ybu = Number(row.YBU_XVALUE) || 0;
          return age + vteHistory + thrombophilia + cancer + lowerExtremity + immobilization + ybu;
        },
      },
    ],
    mcpConfig: {
      AGE: { mcpId: 735, field: "AGE", scoreField: "AGE_XVALUE" },
      VTE_HISTORY: { mcpId: 736, field: "VTE_HISTORY", scoreField: "VTE_HISTORY_XVALUE" },
      THROMBOPHIA: { mcpId: 737, field: "THROMBOPHIA", scoreField: "THROMBOPHIA_XVALUE" },
      CANCER: { mcpId: 738, field: "CANCER", scoreField: "CANCER_XVALUE" },
      EXMY_PARALYSIS_OR_PARESTHESIS: { mcpId: 739, field: "EXMY_PARALYSIS_OR_PARESTHESIS", scoreField: "EXMY_PARALYSIS_OR_PARES_XVALUE" },
      IMMOBILIZATION: { mcpId: 740, field: "IMMOBILIZATION", scoreField: "IMMOBILIZATION_XVALUE" },
      YBU: { mcpId: 741, field: "YBU", scoreField: "YBU_XVALUE" },
    } as Record<string, { mcpId: number; field: string; scoreField: string }>,
    formData: {
      IVRA_ID: "",
      PROCESS_TIME: new Date(),
      CTIME: new Date(),
      CUSER: "",
      AGE: "",
      VTE_HISTORY: "",
      THROMBOPHIA: "",
      CANCER: "",
      EXMY_PARALYSIS_OR_PARESTHESIS: "",
      IMMOBILIZATION: "",
      YBU: "",
      CALC_VALUE: "",
    },
    chartScoreField: "CALC_VALUE",
    chartTimeField: "PROCESS_TIME",
  };